<template>

	<b-card class="auto-form">

		<template v-if="wrongConfig">
			<div slot="header">
				Hay un error de configuración.
			</div>
			<p>
				Por favor rectifica el origen y que el registro que buscas aún exista.
			</p>
		</template>

		<template v-else>

			<div slot="header">{{formLabel}}</div>

			<spinner v-if="loading"/>
			
			<b-form class="animated fadeIn" @submit="triggerDataUpdate()" v-else>

				<b-row>
					<b-col sm="12">

						<b-form-group v-for="item in sourceNotHidden" :key="item.name">

							<!-- GENERAL LABEL -->
							<label v-if="item.type != 'checkbox'" :for="item.name">{{item.label}}</label>

							<!-- INPUTS -->
							<template v-if="item.type == 'file'">

								<b-row >
									<b-col no-gutter class="mb-4 pb-1">
										<label :for="item.name">
											<api-img :comp="originalData[item.name]"/>
										</label>
									</b-col>
								</b-row>

								<b-form-file :state="Boolean(data[item.name])"
									v-model="data[item.name]"
									:id="item.name"
									v-if="!(!!item.readonly)"
									:required="item.required"
									placeholder="Selecciona el archivo o sueltalo aquí..."
									drop-placeholder="Suélta el archivo..."></b-form-file>

								<div class="mt-3" v-if="!(!!item.readonly) && Boolean(data[item.name])">Archivo seleccionado: {{ data[item.name] ? data[item.name].name : '' }}</div>

							</template>

							<fk-select  v-else-if="item.type == 'fk'"
								v-model="data[item.name]"
								:edited="dataMD5"
								:item="item" :full-data="data"></fk-select>

							<b-form-select  v-else-if="item.type == 'selectmultiple' || item.type == 'select'"
								v-model="data[item.name]"
								:multiple="item.type == 'selectmultiple'"
								:id="item.name"
								:readonly="item.readonly"
								:required="item.required"
								:options="item.fieldOptions.options"></b-form-select>

							<b-form-checkbox v-else-if="item.type == 'checkbox'" v-model="data[item.name]"
								:id="item.name"
								:readonly="item.readonly"
								:required="item.required"
								value="1"
								unchecked-value="0" > {{item.label}} </b-form-checkbox>

							<b-form-input v-else-if="item.name == 'monto'" v-model="data[item.name]" 
								step="0.01"
								:type="item.type" 
								:id="item.name" 
								:required="item.required"
								:readonly="item.readonly"></b-form-input>

							<b-form-input v-else v-model="data[item.name]" 
								:type="item.type" 
								:id="item.name" 
								:required="item.required"
								:readonly="item.readonly"></b-form-input>

						</b-form-group>

					</b-col>
				</b-row>
				
				<input v-for="hiddenItem in sourceHidden" :key="hiddenItem.name" v-model="data[hiddenItem.name]" 
					:type="hiddenItem.type" 
					:id="hiddenItem.name" 
					:required="hiddenItem.required"
					:readonly="hiddenItem.readonly" />
				
				<b-row class="auto-form-buttons animated fadeIn" v-if="maySaved">
					<b-col>
						<button type="button" @click="reset()" class="btn btn-block btn-warning"> <i class="fa fa-times"></i> Cancelar</button>
					</b-col>
					<b-col >
						<button type="submit" class="btn btn-block btn-primary"><i class="fa fa-check"></i>	Guardar</button>
					</b-col>
				</b-row>
				
				<b-row class="auto-form-buttons animated fadeIn" v-else-if="mayDeleted">
					<b-col>
						<button type="button" @click="tryDelete()" class="btn btn-block btn-danger"> <i class="fa fa-trash"></i> Borrar</button>
					</b-col>
				</b-row>

			</b-form>

		</template>

	</b-card>

</template>

<style lang="less">
	.auto-form {
		&-buttons {
			padding-top: 1.2em;
			border-top: 1px solid var(--dark);
		}
	}
</style>

<script>
	import _ from 'lodash'
	import axios from 'axios'
	import fkSelect from '@/views/elements/fk-select.vue'
	import md5 from 'js-md5'

	export default {

		props: {
			originId: {
				type: [Number, String],
				default: null
			},
			origin: {
				type: String,
				default: null
			},
			title: {
				type: String,
				default: ''
			}
		},

		data: () => {
			return {
				edited: 0,
				wrongConfig: false,
				loading: true,
				originalData: {},
				data: {},
				ghostData: {},
				source: [],
				resulting_id: null
			}
		},

		components: {
			fkSelect
		},

		computed: {
			sourceNotHidden(){
				return _.filter(this.source, (item) => {
					if(item.type != 'hidden')
						return item
				})
			},
			sourceHidden(){
				return _.filter(this.source, (item) => {
					if(item.type == 'hidden')
						return item
				})
			},
			conformedURI(){
				return this.origin + "/" + ((!!this.resulting_id) ? this.resulting_id : this.originId)
			},
			formLabel(){
				return (this.title != '')? this.title : 'Formulario automático'
			},
			mayDeleted(){
				return (!this.maySaved && (!!this.resulting_id || !!this.originId))
			},
			maySaved(){
				return (JSON.stringify(this.data) != JSON.stringify(this.originalData))
			},
			dataMD5(){
				return md5(JSON.stringify(this.data))
			}
		},

		methods: {
			tryPostingFiles(response){
				let data = new FormData();
				let count = 0
				this.resulting_id = response.resulting_id
				_.forEach(this.data, (postingFile, keyname) => {
					if(!!postingFile && (postingFile.type == 'image/jpg' ||postingFile.type == 'image/jpeg' || postingFile.type == 'image/png')){
						data.append(keyname, postingFile, postingFile.name);
						count++;
					}
				})
				if(count){
					axios.post(this.conformedURI, data, {
						headers: {
							'accept': 'application/json',
							'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
						}
					}).then( this.updateComponent )
				} else {
					this.updateComponent(response)
				}
			},
			reset(){
				this.loading = true
				setTimeout(()=> {
					this.data = _.cloneDeep(this.originalData)
					this.loading = false
				}, 100)
			},
			updateComponent(response){

				if(!!response.source)
					this.source = response.source

				if(!!response.originalData)
					this.originalData = response.originalData

				if(response.status)
					this.reset()
				else 
					this.loading = false
			},
			defineFromURI(){
				this.loading = true
				axios.get(this.conformedURI).then( this.updateComponent )
			},
			triggerDataUpdate(){
				this.loading = true
				let data2send = {}
				let definition
				_.forEach(this.source, item => {
					if(!item.readonly && item.type != 'file')
						data2send[item.name] = null
				})
				_.forEach(this.data, (value, name) => {
					definition = _.find(this.source, {name})
					if(!!definition && !definition.readonly && definition.type != 'file')
						data2send[name] = value
				})
				console.log(data2send);
				axios.post( this.conformedURI, data2send ).then(this.tryPostingFiles)
			},
			tryDelete(){
				if(confirm('¿Seguro?')){
					axios.delete(this.conformedURI).then((r) => {console.log(r); this.$router.go(-1)});
				}
			}
		},

		mounted(){
			if(!this.origin){
				this.wrongConfig = true
			} else {
				this.defineFromURI()
			}
		}

	}
</script>